import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {To} from "react-router";
import {AppState} from "lib/redux/store";

interface LoginState {
    to: To
    userName: string
    userNameError: string | null
    password: string
    passwordError: string | null
}

const initialState: LoginState = {
    to: "/",
    userName: "",
    userNameError: null,
    password: "",
    passwordError: null
}

const {actions, reducer} = createSlice({
    name: "login",
    initialState: initialState,
    reducers: {
        setTo: (state, action: PayloadAction<To>) => {
            state.to = action.payload;
        },
        setUserName: (state, action: PayloadAction<string>) => {
            state.userName = action.payload;
        },
        setUserNameError: (state, action: PayloadAction<string | null>) => {
            state.userNameError = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
        setPasswordError: (state, action: PayloadAction<string | null>) => {
            state.passwordError = action.payload;
        },
        removeErrors: (state) => {
            state.userNameError = null;
            state.passwordError = null;
        },
        reset: (state) => {
            state.to = "/";
            state.userNameError = null;
            state.password = "";
            state.passwordError = null;
        }
    }
});

function getLoginState(state: AppState): LoginState {
    return state.login;
}

const selectors = {
    to: (state: AppState) => getLoginState(state).to,
    userName: (state: AppState) => getLoginState(state).userName,
    userNameError: (state: AppState) => getLoginState(state).userNameError,
    password: (state: AppState) => getLoginState(state).password,
    passwordError: (state: AppState) => getLoginState(state).passwordError,
}

export {actions as loginActions};
export {reducer as loginReducer};
export {selectors as loginSelectors};